import { render, staticRenderFns } from "./IconEdit.vue?vue&type=template&id=73568160&"
import script from "./IconEdit.vue?vue&type=script&lang=js&"
export * from "./IconEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73568160')) {
      api.createRecord('73568160', component.options)
    } else {
      api.reload('73568160', component.options)
    }
    module.hot.accept("./IconEdit.vue?vue&type=template&id=73568160&", function () {
      api.rerender('73568160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconEdit.vue"
export default component.exports